import React from "react";
import "./Career.css";

const roles = [
  "Credit Manager",
  "Credit Executive",
  "Collection Executive",
  "IT Specialist",
  "Customer Support",
  "Admin",
  "HR",
  "And many more..."
];

const emails = [
  "Rajeev@namanfinlease.com",
  "nodalofficer@namanfinlease.com"
];
const phone = "9990831500";

const Career = () => (
  <div className="career-page">
    <h1 className="career-title">Grow Your Career with Naman Finlease</h1>
    <p className="career-intro">
      At Naman Finlease, we believe in nurturing talent and providing opportunities for professional growth. We are always looking for passionate and dedicated individuals to join our team in a variety of roles:
    </p>
    <ul className="career-roles">
      {roles.map((role, idx) => (
        <li key={idx}>{role}</li>
      ))}
    </ul>
    <div className="career-contact">
      <p>If you are interested in building your career with us, please send your resume or queries to:</p>
      <div className="career-contact-info">
        <b>Email:</b> {emails.map((mail, i) => (
          <span key={i}>{mail}{i < emails.length - 1 ? ", " : ""}</span>
        ))}<br/>
        <b>Phone:</b> {phone}
      </div>
      <p className="career-note">We look forward to welcoming driven professionals who want to grow with us!</p>
    </div>
  </div>
);

export default Career; 